import { TemplatePage } from './types';

const recipePage: TemplatePage = {
  header: {
    color: '#CBDEDA',
    icon: 'images/video-templates/recipe.jpg',
    title: 'Recipe Video Templates',
    title_meta: 'Customizable & Free Recipe Video Templates',
    description_meta:
      'Spice up your social channels with Wave.video’s 50+ easy-to-edit recipe video templates. Perfect for the promotion ' +
      'of cooking blogs, restaurants, and more.',
    description:
      'Spice up your social channels with Wave.video’s easy-to-edit recipe video templates. <br>Perfect for the promotion of ' +
      'food blogs, cooking classes, restaurants, and more.'
  },
  footer: {
    category: 'Recipe',
    description:
      'With Wave.video’s wide collection of mouth-watering editable recipe video templates, you won’t spend hours making ' +
      'and editing video content. All you need to do is choose a template of your liking, customize it to fit your branding, ' +
      'and download, embed it on a website, or share via social media. All the templates come in the most popular social media ' +
      'formats so that you can easily repurpose your video content for multiple platforms.'
  },
  content: [
    {
      type: 'templates',
      title: 'recipe',
      search: { name: 'recipe' }
    },
    {
      type: 'stocks',
      title: 'recipe',
      search: { name: 'recipe' }
    },
    { type: 'calendar' }
  ]
};

export default recipePage;
